function Turkey({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2350)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
  <path d="M15.3448 13.0742L16.6576 14.8833L18.7837 14.1939L17.4688 16.0014L18.7814 17.8104L16.6561 17.1184L15.3413 18.9259L15.3427 16.6908L13.2173 15.9988L15.3434 15.3095L15.3448 13.0742Z" fill="#F0F0F0"/>
  <path d="M11.7621 20.5216C9.26483 20.5216 7.24033 18.4971 7.24033 15.9998C7.24033 13.5026 9.26483 11.4781 11.7621 11.4781C12.5407 11.4781 13.2733 11.675 13.913 12.0216C12.9095 11.0402 11.5372 10.4346 10.023 10.4346C6.94933 10.4346 4.45776 12.9262 4.45776 15.9998C4.45776 19.0733 6.94939 21.5649 10.023 21.5649C11.5373 21.5649 12.9096 20.9593 13.913 19.9779C13.2733 20.3246 12.5407 20.5216 11.7621 20.5216Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Turkey;
